// Components==============
import { faPlay } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React, { useEffect, useRef, useState } from 'react';
import { interactiveScale } from 'utilities/FramerAnimations';
import { getSmartImage } from 'utilities/getSmartImage';
import './ImageSelector.module.scss';
// =========================

type Props = {
  images: { path: string; name?: string }[];
  video?: string;
  currentImage: string;
  setCurrentImage: React.Dispatch<React.SetStateAction<string>>;
  shouldGoDown?: boolean;
};

const ThumbNail = ({
  image,
  currentImage,
  setCurrentImage,
  type,
}: {
  image: { path: string; name?: string };
  currentImage: string;
  setCurrentImage: React.Dispatch<React.SetStateAction<string>>;
  type: 'image' | 'video';
}) => (
  <motion.button
    type="button"
    styleName={`image ${currentImage === image.path ? 'active' : ''}`}
    onClick={() => setCurrentImage(image?.path)}
    {...interactiveScale}
  >
    {type === 'image' && (
      <img
        src={getSmartImage(image.path, image?.name)}
        styleName="thumbnail"
        alt="thumbnail"
      />
    )}
    {type === 'video' && (
      <div styleName="thumbnail video">
        <FontAwesomeIcon icon={faPlay} />
      </div>
    )}
  </motion.button>
);

export default function ImageSelector({
  images,
  video,
  currentImage,
  setCurrentImage,
  shouldGoDown,
}: Props) {
  const ref = useRef<HTMLDivElement>(null);

  const [hasScrollbar, setHasScrollbar] = useState(false);

  useEffect(() => {
    if (ref.current && ref.current?.scrollWidth > ref.current?.clientWidth)
      setHasScrollbar(true);
  }, []);

  if ((video && images?.length > 0) || images?.length > 1)
    return (
      <motion.div
        initial={{ y: '50%' }}
        animate={shouldGoDown ? { y: 'calc(50% + 10px)' } : { y: '50%' }}
        styleName="wrapper"
        style={{
          gridTemplateColumns: `repeat(${
            video ? images.length + 1 : images.length
          }, 45px)`,
          justifyContent: hasScrollbar ? 'initial' : 'center',
        }}
        ref={ref}
      >
        {images?.map((image, i) => (
          <ThumbNail
            key={i}
            type="image"
            image={image}
            currentImage={currentImage}
            setCurrentImage={setCurrentImage}
          />
        ))}
        {video && (
          <ThumbNail
            type="video"
            image={{ path: video }}
            currentImage={currentImage}
            setCurrentImage={setCurrentImage}
          />
        )}
      </motion.div>
    );

  return <></>;
}
